import { Component, OnInit } from '@angular/core';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { DataService } from 'src/app/shared/services/data.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { LowInformationContact } from 'src/app/shared/models/iContact/contact/low-information-contact';

@Component({
  selector: 'app-courrier-for-tabs',
  templateUrl: './courrier-for-tabs.component.html',
  styleUrls: ['./courrier-for-tabs.component.scss'],
})
export class CourrierForTabsComponent implements OnInit {
  public contacts: LowInformationContact[] = [];
  constructor(
    private contactsService: ContactsService,
    public dataService: DataService
  ) {}
  ngOnInit(): void {
    this.getAllContact();
  }

  public getAllContact(): void {
    this.contactsService.getLowInformationsContactsiCourrier({ includeAddressPrincipal: true }).subscribe({
      next: (response) => {
        const temp = [];

        response.map((contact) => {
          temp.push(new Contact(contact));
        });

        this.contacts = temp;
        this.contacts.map((c) => {
          if (c) {
            c.name = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
            c.label = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
            c.value = c.id;
          }
        });
        this.dataService.setAllContacts(this.contacts);
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }
}
